import React from 'react'
import { Col } from 'react-bootstrap'
import { Field, reduxForm, formValueSelector } from 'redux-form'
import { connect } from 'react-redux'
import { FORM_CUPO } from '../../../config/forms'
import { EMPLY_BLOQUEO_CUPO } from '../actions/constants'
import { renderDateMaterialField } from '../../Forms/fieldRenderers'
import { required } from '../../Forms/fieldValidators'
import { FormControlLabel, Switch, Grid, Checkbox } from '@material-ui/core'

const BloqueoDeCuposDialogView = (props) => {
  const { bloqueoTotal, cupos } = props
  const cerealesDisponibles = []
  const exportadoresDisponibles = []
  let cereales = []
  let exportadores = []

  cupos.map(cupo => {
    if (!cerealesDisponibles.includes(cupo.claveCereal)) {
      cerealesDisponibles.push(cupo.claveCereal)
    }
    if (!exportadoresDisponibles.includes(cupo.exportador)) {
      exportadoresDisponibles.push(cupo.exportador)
    }
    return [cerealesDisponibles, exportadoresDisponibles]
  })

  const changeBloqueoTotal = () => {
    const { change: formChange } = props
    formChange('bloqueoTotal', !bloqueoTotal)
    formChange('cereal', '')
    formChange('exportador', '')
    cereales = []
    exportadores = []
  }

  const addCereal = (c) => {
    const { change: formChange } = props
    if (!cereales.includes(c)) {
      cereales.push(c)
    } else {
      cereales.pop(c)
    }
    formChange('cereal', cereales)
  }

  const addExportador = (e) => {
    const { change: formChange } = props
    if (!exportadores.includes(e)) {
      exportadores.push(e)
    } else {
      exportadores.pop(e)
    }
    console.log(exportadores)
    formChange('exportador', exportadores)
  }

  return (
    <>
      <Col md={12}>
        <Grid container justify='space-around'>
          { !(props.bloqueoTotal) && <>
            <Field
              autoOk
              name='fechaD'
              emptyLabel
              component={renderDateMaterialField}
              value={new Date()}
              autoFocus={false}
              validate={[required]}
              helperText='Fecha desde'
              disablePast
              placeholder={``}
              showTodayButton
              todayLabel='Hoy'
            />
            <Field
              autoOk
              name='fechaH'
              emptyLabel
              component={renderDateMaterialField}
              value={new Date()}
              autoFocus={false}
              validate={[required]}
              helperText='Fecha hasta'
              disablePast
              placeholder={``}
              showTodayButton
              todayLabel='Hoy'
            />
          </>}

          <FormControlLabel
            control={<Switch
              color='primary'
              name='bloqueoToTal'
              onChange={changeBloqueoTotal}
              checked={bloqueoTotal}
            />}
            label='Bloquear todos los cupos'
          />
        </Grid>
        {bloqueoTotal && <p style={{ textAlign: 'center' }}>Puede desactivar el bloqueo total para filtrar por fecha, cereales y/o exportadores</p> }
      </Col>

      <></>

      {!(props.bloqueoTotal) && <div className='container-opciones-bloqueo'>
        <Col md={4}>
          {cerealesDisponibles.map((cereal) => (
            <FormControlLabel
              style={{ width: '60%', margin: '0px' }}
              key={cereal}
              control={
                <Checkbox
                  onChange={() => { addCereal(cereal) }}
                  color='primary'
                />
              }
              label={cereal}
            />
          ))
          }
        </Col>

        <Col md={8}>
          {exportadoresDisponibles.map((exportador) => (
            <FormControlLabel
              style={{ width: '100%', margin: '0px' }}
              key={exportador}
              control={
                <Checkbox
                  onChange={() => { addExportador(exportador) }}
                  color='primary'
                />
              }
              label={exportador}
            />
          ))
          }
        </Col>
      </div>
      }

    </>
  )
}

const selector = formValueSelector(FORM_CUPO)

const mapStateToProps = state => {
  return {
    cupos: state.cupos.cuposVigentes,
    bloqueoTotal: selector(state, 'bloqueoTotal')
  }
}

export default reduxForm({
  form: FORM_CUPO,
  initialValues: EMPLY_BLOQUEO_CUPO,
  enableReinitialize: true
})(connect(mapStateToProps)(BloqueoDeCuposDialogView))
